import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, input, OnInit, Output, signal, ViewChild } from '@angular/core';
import { GithubIssueViewModel, SupportTicketMessageViewModel, SupportTicketViewModel, SupportTicketFileViewModel } from '../../../../../core/api/models';
import { TicketsApiService } from '../../../../../core/api/services';
import { AlertService } from '../../../../../shared/services/alert.service';
import { Utils } from '../../../../../core/utils';
import { Router } from '@angular/router';
import { CKEditorComponent, CKEditorModule } from '@ckeditor/ckeditor5-angular';
// CKEditor imports
import { Editor, editorConfig } from '../../../../../shared/ckeditor/ckeditor-config';
import { environment } from "../../../../../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: 'app-ticket-list-item',
  templateUrl: './ticket-list-item.component.html',
  styleUrls: ['./ticket-list-item.component.css'],
  standalone: false
})
export class TicketListItemComponent implements OnInit, AfterViewInit {
  @Input() ticket: SupportTicketViewModel = {};
  @ViewChild('messageContainer') messageContainer!: ElementRef;
  @ViewChild('newMessageEditor') editorComponent!: CKEditorComponent;
  @ViewChild('editMessageEditor') editMessageComponent!: CKEditorComponent;
  @Output() updatePinnedTickets = new EventEmitter<SupportTicketViewModel>()
  @Output() reloadTickets = new EventEmitter<void>()

  showTicket: boolean = false;
  gitHubIssueVisible: boolean = false;
  loadingGitHubIssue: boolean = false;
  gitHubIssues: GithubIssueViewModel[] | null = null;
  gitHubIssue: GithubIssueViewModel | null = null;
  gitHubComment?: string;
  loading: boolean = false;

  selectedMessage?: SupportTicketMessageViewModel;
  selectedMessageID: number | null | undefined = null;
  doEdit: boolean = false;
  editingMessageID: number | null | undefined = null;

  selectedAttachmentURL?: string | null = null;
  selectedAttachmentName?: string | null | undefined = "";
  selectedAttachmentID?: number | undefined = 0;
  selectedFile?: SupportTicketFileViewModel | null | undefined = null;
  attachmentModalVisible: boolean = false;
  loadingAttachment: boolean = false;

  public Editor = Editor;
  public editorConfig = editorConfig;

  initialNewMessage: string = '';
  adminViewOnly: boolean = false;
  newMessage = signal('');
  editMessage = signal('');

  constructor(
    private apiService: TicketsApiService,
    private alertService: AlertService,
    private router: Router,
    private cdref: ChangeDetectorRef,
    private http: HttpClient
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  toggleTicket() {
    this.showTicket = !this.showTicket;
    if (!this.ticket.IsFullyLoaded) {
      this.loading = true;
      this.apiService.Get({
        body: {
          id: this.ticket.ID || 0
        }
      })
        .forEach(
          (result) => {
            this.loading = false;
            if (result) {
              this.ticket = result;
            }
          }
        ).catch(
          err => {
            this.loading = false;
            this.alertService.error(Utils.getAjaxError(err));

          });
    }
  }

  doPinTicket() {
    this.ticket.IsPinnedByUser = this.ticket.IsPinnedByUser == null ? true : !this.ticket.IsPinnedByUser;
    this.updatePinnedTickets.emit(this.ticket);
  }

  doSetClosed() {
    var model = {
      id: this.ticket.ID
    }
    this.apiService.SetClosed({ body: model })
      .forEach(
        (result) => {
          if (result)
            this.reloadTickets.emit();
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  openMoreInfo() {
    const url = this.router.serializeUrl(this.router.createUrlTree(['tickets/' + this.ticket.ID]));
    window.open(url, "_blank");
  }

  getGitHubLink() {
    if (this.ticket?.GitHub_IssueNumber) {
      var url = `https://github.com/UTBS/${this.ticket?.GitHub_Repository}/issues/${this.ticket?.GitHub_IssueNumber}`;
      return url;
    }
    else return "";
  }

  openGitHubLink() {
    if (this.ticket?.GitHub_IssueNumber) {
      var url = `https://github.com/UTBS/${this.ticket?.GitHub_Repository}/issues/${this.ticket?.GitHub_IssueNumber}`;
      var w = window.open(url, '_blank');
      return;
    }
  }

  showLinkGitHub() {
    if (this.ticket?.GitHub_IssueNumber) {
      var url = `https://github.com/UTBS/${this.ticket?.GitHub_Repository}/issues/${this.ticket?.GitHub_IssueNumber}`;
      var w = window.open(url);
      if (!w)
        location.href = url;
      return;
    }

    this.gitHubIssueVisible = true;

    if (!this.gitHubIssues) {
      this.loadingGitHubIssue = true;
      this.apiService.GetGitHubIssues()
        .forEach((result) => {
          this.loadingGitHubIssue = false;
          result.splice(0, 0, { title: 'New Issue', number: 0, repository: 'utbs_optomiser' });

          this.gitHubIssues = result;
          var myTitle = this.ticket?.Subject || '';
          var r = result.find(x => x.title && myTitle.startsWith(x.title))
          if (!r)
            r = result[0];

          this.gitHubIssue = r;

        }).catch(
          err => {
            this.loadingGitHubIssue = false;
            this.alertService.error(Utils.getAjaxError(err));
          });
    }

  }


  linkGitHub() {
    if (!this.ticket || !this.ticket.ID || !this.gitHubIssue)
      return;
    console.debug(this.gitHubIssue);


    this.loading = true
    this.apiService.LinkGitHubIssue({
      body: {
        IDs: [this.ticket!.ID || 0],
        GitHub_IssueNumber: this.gitHubIssue.number,
        GitHub_Repository: this.gitHubIssue.repository || undefined,
        comment: this.gitHubComment || undefined
      }
    })
      .forEach((result) => {
        this.loading = false;
        this.gitHubIssueVisible = false;
        this.ticket!.GitHub_IssueNumber = result.number;
        this.ticket!.GitHub_Repository = result.repository;
        this.alertService.success('Item linked successfully');

      }).catch(
        err => {
          this.loading = false;
          this.alertService.error(Utils.getAjaxError(err));
        });
  }


  changeMessageAdminView(message: SupportTicketMessageViewModel) {
    if (!message) {
      return;
    }
    this.loading = true
    var model = {
      id: message.ID
    };

    this.apiService.SetMessageAdminView({ body: model })
      .forEach(
        (result) => {
          if (result) {
            setTimeout(() => { this.setMessageLoadingFalse(message) }, 2000);
          }
        }).catch(
          err => {
            this.loading = false;
            this.cdref.detectChanges();
            this.alertService.error(Utils.getAjaxError(err));
          });

  }

  setMessageLoadingFalse(message: SupportTicketMessageViewModel) {
    this.loading = false
  }

  showMessageMenu(message: SupportTicketMessageViewModel) {
    if (this.selectedMessage == message) {
      this.selectedMessage = undefined;
      this.selectedMessageID = null;
    }
    else {
      this.selectedMessage = message;
      this.selectedMessageID = message.ID;
    }
  }

  showEditMessage(message: SupportTicketMessageViewModel) {
    this.editingMessageID = message.ID;
    if (this.selectedMessage == message) {
      this.doEdit = true;
      this.editingMessageID = message.ID;
      this.selectedMessage = undefined;
      this.selectedMessageID = null;
    }
    else {
      this.doEdit = false;
      this.editingMessageID = 0;
    }
  }

  cancelEdit(message: SupportTicketMessageViewModel) {
    this.doEdit = false;
    this.editingMessageID = 0;
  }

  sendNewMessage() {
    var model = {
      ticketID: this.ticket?.ID,
      message: this.newMessage(),
      isAdminView: this.adminViewOnly
    }
    this.apiService.SendNewMessage({ body: model })
      .forEach(
        (result) => {
          if (result) {
            this.ticket?.Messages?.push(result);
            setTimeout(() => { this.scrollToBottomOfMessages() }, 200);
            this.newMessage.set("");
            this.clearEditor();
          }
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  scrollToBottomOfMessages(): void {
    if (this.messageContainer) {
      const element = this.messageContainer.nativeElement;
      element.scrollTo({ top: element.scrollHeight, behavior: 'smooth' })
    }
  }

  doEditMessage(message: SupportTicketMessageViewModel) {
    if (!message) {
      return;
    }
    var model = {
      messageID: message.ID,
      message: this.editMessage()
    }
    this.apiService.EditMessage({ body: model })
      .forEach(
        (result) => {
          if (result) {
            message.Message = result.Message;
            message.MessageHtml = result.MessageHtml;
            this.doEdit = false;
          }
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  deleteMessage(id: number | undefined) {
    if (!id) {
      return;
    }
    var model = {
      messageID: id
    }
    this.apiService.DeleteMessage({ body: model })
      .forEach(
        (result) => {
          if (result) {
            if (this.ticket != null) {
              if (this.ticket.Messages != null && this.ticket.Messages.length > 0) {
                this.ticket.Messages = this.ticket.Messages.filter(x => x.ID != id);
              }
            }
          }
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  clearEditor() {
    if (this.editorComponent && this.editorComponent.editorInstance) {
      this.editorComponent.editorInstance.setData('');
    }
  }

  isImageAttachment(file: SupportTicketFileViewModel): boolean {
    if (file.ImageThumbnail && file.ImageThumbnail.trim() !== '') {
      return true;
    }
    return false;
  }

  getAttachmentThumbnail(file: SupportTicketFileViewModel): string {
    if (file.ImageThumbnail && file.ImageThumbnail.trim() !== '') {
      const type = file.FileType && file.FileType.trim() !== ''
        ? file.FileType
        : 'image/png';

      return `data:${type};base64,${file.ImageThumbnail}`;
    }

    return '/assets/icon-navy-144.png';
  }
  modalIsImageAttachment(): boolean {
    if (this.selectedFile != null) {
      if (
        this.selectedFile.FileType && this.selectedFile.FileType.trim() !== '') {
        return this.selectedFile.FileType.startsWith('image/');
      }
      return false;
    }
    return false;
  }

  getModalAttachmentImage() {

    if (this.selectedAttachmentURL != null) {
      return this.selectedAttachmentURL;
    }
    else if (this.selectedFile && this.selectedFile.ImageThumbnail && this.selectedFile.ImageThumbnail.trim() !== '') {
      const type = this.selectedFile.FileType && this.selectedFile.FileType.trim() !== ''
        ? this.selectedFile.FileType
        : 'image/png';

      return `data:${type};base64,${this.selectedFile.ImageThumbnail}`;
    }
    else {
      return '';
    }
  }

  getModalAttachmentThumbnail() {
    if (this.selectedFile != null) {
      if (this.selectedFile.ImageThumbnail != null && this.selectedFile.ImageThumbnail != "") {
        return 'data:' + (this.selectedFile.FileType == " " || this.selectedFile.FileType == null ? 'image/png' : this.selectedFile.FileType) + ';base64,' + this.selectedFile.ImageThumbnail;
      }
      else {
        return 'assets/images/file-icon.png';
      }
    }
    else {
      return 'assets/images/file-icon.png';
    }
  }

  doShowAttachment(attachment: SupportTicketFileViewModel) {
    this.selectedAttachmentName = "";


    this.selectedAttachmentName = attachment.FileName;
    this.selectedAttachmentURL = null;
    this.selectedAttachmentID = attachment.ID;
    this.selectedFile = attachment;
    this.attachmentModalVisible = true;

    if ((attachment.ImageThumbnail && attachment.ImageThumbnail.trim() !== '')
      || (this.selectedFile.FileType && this.selectedFile.FileType.startsWith('image/'))) {
      this.loadingAttachment = true;

      this.apiService.GetAttachmentURL({
        body: {
          id: this.selectedAttachmentID
        }
      })
        .forEach(
          (result) => {
            this.loadingAttachment = false;
            if (result) {
              this.selectedAttachmentURL = result;
              console.log(result);
            } else {
              // download bytes
              this.http.get(environment.webApiRoot + '/api/Tickets/GetAttachmentData?id=' + this.selectedAttachmentID,
                {
                  observe: 'response',
                  responseType: 'blob'
                })

                .forEach(
                  (data: any) => {
                    if (data) {
                      const blob = new Blob([data.body], { type: attachment.FileType || 'image/png' });
                      this.selectedAttachmentURL = URL.createObjectURL(blob);
                    }
                  }).catch(
                    err => {
                      this.alertService.error(Utils.getAjaxError(err));
                    });
            }
          }).catch(
            err => {
              this.loadingAttachment = false;
              this.alertService.error(Utils.getAjaxError(err));
            });
    }

  }
  doDownloadAttachment() {
    if (this.selectedAttachmentURL != null) {
      window.open(this.selectedAttachmentURL, "_blank");
      return;
    }
    var model = {
      id: this.selectedAttachmentID
    }
    this.apiService.GetAttachmentURL({ body: model })
      .forEach(
        (result) => {
          if (result) {
            window.open(result, "_blank");
            console.log(result);
          } else {
            // download bytes
            this.http.get(environment.webApiRoot + '/api/Tickets/GetAttachmentData?id=' + this.selectedAttachmentID,
              {
                observe: 'response',
                responseType: 'blob'
              })
              //this.apiService.GetAttachmentData$Response({
              //  
              //    id: this.selectedAttachmentID
              //  })
              .forEach(
                (data: any) => {
                  if (data) {

                    let filename = this.selectedFile!.FileName || "File.png";
                    let disposition = data.headers.get('Content-Disposition');
                    if (disposition && disposition.indexOf('attachment') !== -1) {
                      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                      var matches = filenameRegex.exec(disposition);
                      if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                    }

                    let type = data.headers.get('Content-Type') || this.selectedFile!.FileType || '';

                    let blob;
                    if (typeof File === 'function') {
                      try {
                        blob = new File([data.body], filename, { type: type });
                      } catch (e) { /* Edge */ }
                    }
                    if (typeof blob === 'undefined') {
                      blob = new Blob([data.body], { type: type });
                    }



                    // IE doesn't allow using a blob object directly as link href
                    // instead it is necessary to use msSaveOrOpenBlob
                    let winNav: any = window.navigator;
                    if (window.navigator && winNav.msSaveOrOpenBlob) {
                      winNav.msSaveOrOpenBlob(blob, filename);
                      return;
                    }
                    let URL = window.URL || (window as any).webkitURL;
                    let downloadUrl = URL.createObjectURL(blob);

                    if (filename) {
                      // use HTML5 a[download] attribute to specify filename
                      let a = document.createElement("a");
                      // safari doesn't support this yet
                      if (typeof a.download === 'undefined') {
                        window.location.href = downloadUrl;
                      } else {
                        a.href = downloadUrl;
                        a.download = filename;
                        document.body.appendChild(a);
                        a.click();
                      }
                    } else {
                      window.location.href = downloadUrl;
                    }

                    setTimeout(function () {
                      URL.revokeObjectURL(downloadUrl);

                    }, 100); // cleanup

                  }
                }).catch(
                  err => {
                    this.alertService.error(Utils.getAjaxError(err));
                  });
          }
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }
  editorOnChange(event: any) {
    this.newMessage.set(event.editor.getData());
  }
  editMessageChange(event: any) {
    this.editMessage.set(event.editor.getData());
  }
}
